import {
  SettingsGroup,
  SettingsLabel,
} from 'approot/activity-builder/settings/settings.style';
import ActivityBuilderInlineSvg from 'approot/shared/inline-svg/activity-builder/activity-builder-inline-svg';
import { CheckableSingle } from 'approot/shared/styles/buttons/checkable-input';
import {
  FLEX_ALIGN_MIDDLE,
  FLEX_ALIGN_RIGHT,
  FLEX_ALIGN_START,
  ContentFlexAlignment,
} from 'global/constants';

type Props = {
  alignment: ContentFlexAlignment;
  setAlignment: (alignment: ContentFlexAlignment) => void;
};

const SettingTextAligment = ({ alignment, setAlignment }: Props) => (
  <SettingsGroup as="fieldset">
    <SettingsLabel as="legend">Align</SettingsLabel>
    <CheckableSingle
      variant="button"
      isRound
      name="contentAligment"
      options={[
        {
          label: (
            <ActivityBuilderInlineSvg
              id="icon_content_align_left"
              width={24}
              height={24}
            />
          ),
          'aria-label': 'Align content to left',
          value: FLEX_ALIGN_START,
        },
        {
          label: (
            <ActivityBuilderInlineSvg
              id="icon_content_align_centre"
              width={24}
              height={24}
            />
          ),
          'aria-label': 'Align content to center',
          value: FLEX_ALIGN_MIDDLE,
        },
        {
          label: (
            <ActivityBuilderInlineSvg
              id="icon_content_align_right"
              width={24}
              height={24}
            />
          ),
          'aria-label': 'Align content to right',
          value: FLEX_ALIGN_RIGHT,
        },
      ]}
      selected={alignment}
      onSelect={value => setAlignment(value)}
    />
  </SettingsGroup>
);

export default SettingTextAligment;
